<template>
	<div class="myvip_wrap">
		<div class="vipbanner">
			<img src="../assets/images/bg.png" />
		</div>
		<div class="myvip_main" >

			<!--左侧菜单栏-->
			<ul class="vipsidenav">
				<li @click="(tabId=0);leftmenubar()" class="tabId0">
					<a class="head_portrait">
						<img v-if="initialPortrait == null || initialPortrait == ''" src="../assets/images/head.png" />
						<img v-else :src="initialPortrait" />
					</a>
					<a class="usern">{{initialName}}</a>
				</li>
				<li id="storeclick" @click="tabId=1;leftmenubar(0);demotitleclick()" class="tabId">
					<a class="el-icon-thirdicon-Mycollection"></a>
					我的收藏
				</li>
				<li id="questionclick" @click="tabId=2;leftmenubar(1);graphtitleclick()" class="tabId">
					<a class="el-icon-thirdicon-wodetiwen"></a>
					我的提问
				</li>
				<li id="resetclick" @click="tabId=3;leftmenubar(2)" class="tabId">
					<a class="el-icon-thirdicon-xiugaixinxi"></a>
					修改信息
				</li>
				<li id="newsclick" @click="tabId=4;leftmenubar(3)" class="tabId">
					<a class="el-icon-bell"></a>
					消息中心
				</li>
			</ul>

			<!--会员中心-->
			<div class="vipstoremain" v-show="tabId===0">
				<h4 class="vipcenter itemtitle">
			    	会员中心
			    </h4>
				<div class="mystore">
					<ul>
						<li>
							<span class="menuname">
								<h4><i class="el-icon-thirdicon-yonghu-tianchong"></i> 姓名/Name</h4>
							</span>
							<a>{{alterName}}</a>
						</li>
						<li>
							<span class="menuname">
								<h4><i class="el-icon-thirdicon-dianhua"></i> 手机号/Number</h4>
							</span>
							<a>{{initialPhone}}</a>
						</li>
						<li>
							<span class="menuname">
								<h4><i class="el-icon-thirdicon-danwei"></i> 单位/Company</h4>
							</span>
							<a>{{initialCompany}}</a>
						</li>
					</ul>
					<div class="navbottom">
						<span class="gostore navbtn" @click="storeclick()">
							我的收藏
						</span>
						<span class="goquestion navbtn" @click="questionclick()">
							我的提问
						</span>
						<span class="goreset navbtn" @click="resetclick()">
							修改信息
						</span>
					</div>
				</div>
			</div>

			<!--我的收藏-->
			<div class="vipstoremain" v-show="tabId===1">
				<h4 class="itemtitle">
			    	我的收藏
			    </h4>
				<div class="demo_wrap_box">
					<!--我的收藏标题-->
					<div class="store_title">
						<div id="demotitleclick" @click="demotitleId=0;demotitlestyle(0)" class="demotitleId">
							实例
						</div>
						<div @click="demotitleId=1;demotitlestyle(1)" class="demotitleId">
							应用案例
						</div>
						<div @click="demotitleId=2;demotitlestyle(2)" class="demotitleId">
							知识库
						</div>
					</div>

					<!--我的收藏 demo部分-->
					<div class="store_content" v-show="demotitleId===0">
						<ul id="demo_store_nodata" class="demo_store_content">
							
							<li style="cursor: pointer;" v-for="(item,index) in collectDemoData" @click="jumpdemodetail(item.vc_contentcode)">
								<h3>
									{{item.vc_title}}
									<span :id="'showshade_span'+index"   class="el-icon-info" >
										<!--遮罩 @mouseleave="hideShade(index)"-->
										<div :class="'demoshadebox'+index" >
											<div class="demostoremark">
												{{item.vc_abstract}} 
											</div>										
										</div>
									</span>
								</h3>
								<div class="urlbox">
									<img :src="apiUrl+item.vc_coverphoto" style="width: 100%;height: 100%;" />
								</div>
								<div class="bookmark">
									<span class="el-icon-view">
										
									</span>
									{{item.vc_page_view}}
								</div>
							</li>
							<!--<div style="width: 33.3%;" v-if="!collectDemoData" id="demo_store_none">
								<img style="width: 100%;display: block;" src="../assets/images/none.png" />
								<div class="none_data_text">
									暂无数据
								</div>
							</div>-->
						</ul>
					</div>

					<!--我的收藏 graph部分-->
					<div class="store_content" v-show="demotitleId===1">
						<ul id="graph_store_nodata" class='graph_store_content'>
							<li style="cursor: pointer;" v-for="(item,index) in collectGraphData" @click="jumpgraphdetail(item.vc_contentcode)">
								<div class="urlbox">
									<img :src="apiUrl+item.vc_coverphoto" />
									<div class="graphshadebox" >
										<div class="graphstoremark">
											{{item.vc_abstract}}
										</div>										
									</div>
								</div>
								<h3>
									{{item.vc_title}}
								</h3>
								<div class="bookmark">
									<span id="sourcer"><i class="el-icon-thirdicon-morentouxiang"></i>{{item.vc_source}}</span> <span class="el-icon-view viewbox"></span> <!--<span class="viewnum">-->{{item.vc_page_view}}<!--</span>-->
								</div>
							</li>
							<!--<div style="width: 33.3%;height: 100%;" v-if="!collectGraphData" id="graph_store_none">
								<img style="width: 100%;display:block ;" src="../assets/images/none.png" />
								<div class="none_data_text">
									暂无数据
								</div>
							</div>-->
						</ul>
					</div>

					<!--我的收藏 knowledge部分-->
					<div class="store_content" v-show="demotitleId===2">
						<div id="knowledge_store_nodata" class="storeknowledge_wrap">
							<!--<div style="width: 33.3%;" v-if="!collectKnowledgeData" id="storeknowledge_store_none">
								<img style="width: 100%;display:block ;" src="../assets/images/none.png" />
								<div class="none_data_text">
									暂无数据
								</div>
							</div>-->
							<!-- 显示数据开始 -->
							<div style="overflow: hidden;" v-for="item in collectKnowledgeData" @click="jumpRepositoryDetail(item.vc_contentcode)">
								<!-- <h1>{{item.dt_createtime}}----{{item.vc_page_view}}-------{{item.n_stick}}</h1> -->
								<!-- 单张大图 -->
								<div style="cursor: pointer;" class="chunk" v-if="item.n_photo_type == '1'">
									<div class="subject_middle_1">
										<h4>{{item.vc_title}}</h4>
									</div>
									<div class="content_abstract" v-if="!item.vc_coverphoto&&item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
									<div class="subject_middle_picture" v-if="item.vc_coverphoto">
											<img class="subject_middle_picture" :src="apiUrl+item.vc_coverphoto" />
									</div>
								</div>
								
								<!-- 多张小图 -->
								<div class="chunk2" style="cursor: pointer;" v-if="item.n_photo_type == 2">
									<div class="subject_middle_6">
										<h4 >{{item.vc_title}}</h4>
										<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
										<div  v-for="i in item.vc_coverphoto.split(',')" class="subject_middle_5" v-if="i">
											<img class="subject_middle_picture3" :src="apiUrl+i" />
										</div>
									</div>
								</div>
								<!-- 单张小图 -->
								<div class="chunk1" style="cursor: pointer;" v-if="item.n_photo_type == 3">
									<div class="subject_middle_2" v-if="item.vc_coverphoto">
										<img class="subject_middle_picture2" :src="apiUrl+item.vc_coverphoto" />
										<div class="videomark" v-if="item.n_is_video=='1'">
											<i class="el-icon-thirdicon-play_icon" style="color: white;"></i>
										</div>
									</div>
									<div class="subject_middle_3" v-if="item.vc_coverphoto">
										<h4 >{{item.vc_title}}</h4>
										<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
									</div>
									<div class="subject_middle_6" v-if="!item.vc_coverphoto">
										<h4 >{{item.vc_title}}</h4>
										<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
									</div>
								</div>
							</div>
							<!-- 显示数据结束 -->
						</div>
					</div>
				</div>
			</div>

			<!--我的提问-->
			<div class="vipstoremain" v-show="tabId===2">
				<h4 class="itemtitle">
					    	我的提问
			    </h4>
				<div class="graph_wrap_box">
					<div class="store_title">
						<div id="graphtitleclick1" @click="graphtitleId=0;graphtitlestyle(0)" class="graphtitleId">
							实例
						</div>
						<div id="graphtitleclick2" @click="graphtitleId=1;graphtitlestyle(1)" class="graphtitleId">
							应用案例
						</div>
						<div id="graphtitleclick3" @click="graphtitleId=2;graphtitlestyle(2)" class="graphtitleId">
							知识库
						</div>
					</div>

					<!--我的提问demo-->
					<div class="question_content" v-show="graphtitleId===0">
						<ul class="question_content_main">
							<div  style="width: 100%;height: 500px;position: relative;" v-show="!questionDemoData" id="questionDemoData_none">
								<img style="position: absolute;display: block;left: 0; top: 0;right: 0;bottom: 0;margin: auto;" src="../assets/images/none.png" />
							</div>
							<li class="question_content_list" v-for="(item,index) in questionDemoData" :id="item.problemcode">
								<div class="time">{{item.userPhone}} 在{{item.createtime}}针对
									<a>{{item.target}}</a>的问题：</div>
								<div class="question_list_title">{{item.content}}</div>
								<div class="reply_wrap" v-if="item.reply != ''" v-for="i in item.reply">
									<div class="reply" v-if="i.type == 1">管理员在{{i.createtime}}回复：</div>
									<div class="reply" v-if="i.type == 2">{{item.userPhone}}在{{i.createtime}}追问：</div>
									<div class="cont">{{i.content}}</div>
								</div>
								<div :class="'askedboxDemo'+index">
									<textarea class="quiz_box" placeholder="请输入内容" :id="item.problemcode+'s'"></textarea>
									<div class="quiz_button">
										<div class="quizbtn" @click="questionsub(index,item.problemcode,'Demo')">
											发送
										</div>
									</div>
								</div>
								<div :class="'reaskDemo'+index" @click="questionask(index,'Demo')"><i class="el-icon-edit-outline"></i> <span>追问</span></div>
								<div class="bottom_space" style="width: 100%;background: white;">
									
								</div>
							</li>
						</ul>
					</div>

					<!--我的提问图谱库-->
					<div class="question_content" v-show="graphtitleId===1">
						<ul class="question_content_main">
							<div style="width: 100%;height: 500px;position: relative;" v-show="!questionGraphData" id="questionGraphData_none">
								<img style="position: absolute;display: block;left: 0; top: 0;right: 0;bottom: 0;margin: auto;" src="../assets/images/none.png" />
							</div>
							<li class="question_content_list" v-for="(item,index) in questionGraphData"  :id="item.problemcode">
								<div class="time">{{item.userPhone}} 在{{item.createtime}}针对
									<a>{{item.target}}</a>的问题：</div>
								<div class="question_list_title">{{item.content}}</div>
								<div class="reply_wrap" v-if="item.reply != ''" v-for="i in item.reply">
									<div class="reply" v-if="i.type == 1">管理员在{{i.createtime}}回复：</div>
									<div class="reply" v-if="i.type == 2">{{item.userPhone}}在{{i.createtime}}追问：</div>
									<div class="cont">{{i.content}}</div>
								</div>
								<div :class="'askedboxGraph'+index">
									<textarea class="quiz_box" placeholder="请输入内容" :id="item.problemcode+'s'"></textarea>
									<div class="quiz_button">
										<div class="quizbtn" @click="questionsub(index,item.problemcode,'Graph')">
											发送
										</div>
									</div>
								</div>
								<div :class="'reaskGraph'+index" @click="questionask(index,'Graph')"><i class="el-icon-edit-outline"></i> <span>追问</span></div>
								<div class="bottom_space" style="width: 100%;background: white;">
									
								</div>
							</li>
						</ul>
					</div>

					<!--我的提问知识库-->
					<div class="question_content" v-show="graphtitleId===2">
						<ul class="question_content_main">
							<div style="width: 100%;height: 500px;position: relative;" v-show="!questionKnowledgeData" id="questionKnowledgeData_none">
								<img style="position: absolute;display: block;left: 0; top: 0;right: 0;bottom: 0;margin: auto;" src="../assets/images/none.png" />
							</div>
							<li class="question_content_list" v-for="(item,index) in questionKnowledgeData"  :id="item.problemcode">
								<div class="time">{{item.userPhone}} 在{{item.createtime}}针对
									<a>{{item.target}}</a>的问题：</div>
								<div class="question_list_title">{{item.content}}</div>
								<div class="reply_wrap" v-if="item.reply != ''" v-for="i in item.reply">
									<div class="reply" v-if="i.type == 1">管理员在{{i.createtime}}回复：</div>
									<div class="reply" v-if="i.type == 2">{{item.userPhone}}在{{i.createtime}}追问：</div>
									<div class="cont">{{i.content}}</div>
								</div>
								<div :class="'askedboxKnowledge'+index">
									<textarea class="quiz_box" placeholder="请输入内容" :id="item.problemcode+'s'"></textarea>
									<div class="quiz_button">
										<div class="quizbtn" @click="questionsub(index,item.problemcode,'Knowledge')">
											发送
										</div>
									</div>
								</div>
								<div :class="'reaskKnowledge'+index" @click="questionask(index,'Knowledge')"><i class="el-icon-edit-outline"></i> <span>追问</span></div>
								<div class="bottom_space" style="width: 100%;background: white;">
									
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!--修改信息-->
			<div class="vipstoremain" v-show="tabId===3">
				<h4 class="itemtitle">
		    		修改信息
			    </h4>

				<div class="mystore">
					<!--基本信息-->
					<div class="basic_information">
						<h4 >
							基本信息
							<span style="cursor: pointer;" class="updatebutton" @click="updateInfo">
								更新
							</span>
						</h4>
						<ul class="basic_information_content">
							<li>
								<span class="title">
									姓名
								</span>
								<span class="inp">
									<input type="text" v-model="alterName"/>
								</span>
							</li>
							<li>
								<span class="title">
									工作单位
								</span>
								<span class="inp">
									<input type="text" v-model="alterCompany" />
								</span>
							</li>
							<li>
								<span class="title">
									自定义头像
								</span>
								<span class="inp">
									<i class="el-icon-thirdicon-kongxintixing-tanhao"></i><span style="color: #BDBDBD;">仅支持JPG、PNG格式，文件小于1M(方形图)</span>
								</span>
							</li>
						</ul>
						<!--
                                	作者：Robin
                                	时间：2018-10-18
                                	描述：上传头像
                                -->
						<div class="head_portrait_box">
							<div id="app">
						<!--<myUpload field="img" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess" method="POST" v-model="show" :width="110" :height="110" url="" :params="params" :headers="headers" img-format="png"></myUpload>-->
								<myUpload field="img" @crop-success="cropSuccess"  method="POST" v-model="show" url="" :params="params" :headers="headers" img-format="png"></myUpload>
								<div class="head_img_box"  @click="toggleShow">
									<img  :src="alterPortrait?alterPortrait:initialPortrait">
								</div>

								<!--<a class="resetheadpicture" @click="toggleShow">修改头像</a>-->
							</div>
						</div>
						<!--
                                	作者：Robin
                                	时间：2018-10-18
                                	描述：上传头像结束
                                -->
					</div>
					<div class="safety_information">
						<h4>
							安全信息
						</h4>
						<ul class="basic_information_content">
							<li style="position: relative;">
								<span class="title">
											手机号
										</span>
								<span class="inp">
											{{initialPhone}}
										</span>
								<a id="change_phone" style="cursor: pointer;" @click="enterresetnumber($event)">
									<i class="el-icon-thirdicon-xiugaixinxi"></i> 修改
								</a>
							</li>
							<li style="position: relative;">
								<span class="title">
											密码
										</span>
								<span class="inp">
											*********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #B7B7B7;">（建议一个月修改一次）</span>
								</span>
								<a id="change_pwd" style="cursor: pointer;" @click="enterresetpassword($event)">
									<i class="el-icon-thirdicon-xiugaixinxi"></i> 修改
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!---->
			<div class="vipstoremain" v-show="tabId===4">
				<h4 class="vipcenter itemtitle">
					   消息中心
				</h4>
				<div class="mystore">
					<div class="news_content_box">

						<ul v-for="item in informData" v-if="item.n_condition==1">
							<h4>
								<span v-if="item.n_type == '1'">
									注册成功
								</span>
								<span v-if="item.n_type == '2'">
									修改密码成功
								</span>
								<span v-if="item.n_type == '3'">
									修改手机号成功
								</span>
								<span v-if="item.n_type == '4'">
									提问回复通知
								</span>
								<a>
									{{item.dt_careatetime}}
								</a>
							</h4>
							<li>
								<span v-if="item.n_type != '4'" class="menuname1">
								{{item.vc_content}}
								</span>
								<span v-if="item.n_type == '4'" class="menuname">
								 {{item.vc_content}}
								</span>
								<a v-if="item.n_type == '4'" @click="lookProblems(item.vc_problemtype,item.vc_problemcode)">
									点击立即查看>>
								</a>
							</li>
						</ul>
						<ul v-for="item in informData"  v-if="item.n_condition==2" style="color:#b2b2b2">
							<h4>
								<span v-if="item.n_type == '1'">
									注册成功
								</span>
								<span v-if="item.n_type == '2'">
									修改密码成功
								</span>
								<span v-if="item.n_type == '3'">
									修改手机号成功
								</span>
								<span v-if="item.n_type == '4'">
									提问回复通知
								</span>
								<a>
									{{item.dt_careatetime}}
								</a>
							</h4>
							<li>
								<span v-if="item.n_type != '4'" class="menuname1">
								{{item.vc_content}}
								</span>
								<span v-if="item.n_type == '4'" class="menuname">
								 {{item.vc_content}}
								</span>
								<a v-if="item.n_type == '4'" @click="lookProblems(item.vc_problemtype,item.vc_problemcode)">
									点击立即查看>>
								</a>
							</li>
						</ul>

					</div>
				</div>
			</div>
		</div>
		<!--
        	作者：Robin
        	时间：2018-10-18
        	描述：修改信息弹窗
        -->
		<div class="full_mark_box" v-if="flag_full_mark">
			<div id="reset_number_wrap" v-if="reset_number_flag1">
				<div class="reset_number_wrap_top">
					<span id="user_rephone_t" >修改手机号</span>
					<span id="user_rephone_b" style="float: right;display: block;color: #AAAAAA;cursor: pointer;" @click="quitresetnumber" title="点击关闭"><i class="el-icon-close"></i></span>
				</div>
				<div class="reset_number_wrap_main">
					<div class="phonenum">
						<input type="password" placeholder="请输入当前密码" v-model="password1" @blur="passwordVerification" />
						<span id="user_passwordm" style="float: left;text-align: left;"></span>
					</div>
					<div class="phonenum">
						<input @blur="phoneVerification" type="text" placeholder="请输入新手机号" v-model="alterPhone" />
						<span id="user_newphonem" style="float: left;text-align: left;"></span>
					</div>
					<div class="registerdiv reset_phone_verification">
						<input type="text"  placeholder="短信验证码" v-model="UserSMSCode" />
						<a @click="getCode">{{codeStr}}</a>
						<span id="user_SMSmes" style="float: left;text-align: left;color: red;"></span>
					</div>
					<div class="submit_reset_number_finish" @click="SMSVerification">
						完成
					</div>
				</div>
			</div>
			<!--
            	作者：offline
            	时间：2018-10-18
            	描述：修改密码
            -->
			<div id="resetpwd_wrap" v-if="reset_password_flag">
				<div class="resetpwd_wrap_top">
					<span id="pwd_qwe" style="float: left;display: block;color: #3A3A3C;">修改密码</span>
					<span id="pwd_qwe1" style="float: right;display: block;color: #AAAAAA;cursor: pointer;" @click="quitresetpassword" title="点击关闭"><i class="el-icon-close"></i></span>
				</div>
				<div class="resetpwd_wrap_main">

					<div class="oldpwd">
						<input @blur="passwordVerification" type="password" placeholder="请输入当前密码" v-model="password2" />
						<span>
						</span>
					</div>
					<div class="newpwd">
						<input @blur="passwordVerification" type="password" placeholder="请输入新密码" v-model="password3" />
						<span>
						</span>
					</div>
					<div class="newpwd1">
						<input @blur="passwordVerification" type="password" placeholder="请再次输入新密码" v-model="password4" />
						<span>
						
						</span>
					</div>
					<div class="resetfinish" @click="updatePassword">
						完成
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import Bus from '@/bus.js'
	import myUpload from 'vue-image-crop-upload';
	export default {
		data() {
			return {
				apiUrl:this.apiUrl,
				codeStr:'发送短信验证码',
				user_timer_flag:true,
				tabId: 0,
				titleId: 0,
				graphtitleId: 0,
				demotitleId: 0,
				reset_number_flag1: false,
				reset_password_flag: false,
				phone_verification_flag:false,
				flag_full_mark: false,
				password_verification_flag:false,
				phone_flag:false,
				show: false,
				params: {
					token: '',
					name: ''
				},
				headers: {
					smail: '*_~'
				},

				initialCompany: '', //初始工作单位
				initialName: '', //初始用户名
				initialPhone: '', //初始手机号
				initialPortrait: '', //初始头像
				alterName: '', //改变的名称
				alterCompany: '', //改变的工作单位
				alterPortrait: '', //改变的头像
				alterPhone: '', //改变的手机号
				SMSCode: '', //短信验证码
				UserSMSCode: '', //用户输入的短信验证码
				password1: '', //修改信息时填写的密码
				password2: '', //修改密码时填写的当前密码
				password3: '', //修改密码时填写的新密码
				password4: '', //修改密码时填写的重复新密码

				questionType: '1', //问题类型
				questionDemoData: '', //Demo问题数据
				questionGraphData: '', //实例问题数据
				questionKnowledgeData: '', //知识库问题数据

				collectType: '1', //收藏类型
				collectDemoData: '', //Demo收藏数据
				collectGraphData: '', //实例收藏数据
				collectKnowledgeData: '', //知识库收藏数据
				informData: '', //消息数据
			};
		},
		components: {
			myUpload
		},

		//监听数据变化(切换选项卡)
		watch: {
			tabId(val) {
				if(val == '1') {
					//获取收藏数据
					this.getCollect();
				} else if(val == '2') {
					//获取提问数据
					this.getQuestion();
				} else if(val == '3') {
					//robin 20181220 不设置姓名公司
//					this.alterName = this.initialName;
					this.alterCompany = this.initialCompany;
				} else if(val == '4') {
					//获取消息数据
					this.getInform();
				}
			},
			graphtitleId(val) {
				this.questionType = val + 1;
				this.getQuestion();
			},
			demotitleId(val) {
				this.collectType = val + 1;
				this.getCollect();
			},

			//监听路由变化
			$route(to, from) {
				if(to.query.type == 'inform') {
					this.tabId = 4;
					this.leftmenubar(3)
				}
			}
		},

		//keep-alive 组件激活时调用
		activated() {

			//判断是否需要刷新页面
			if(sessionStorage.getItem('isRefresh')){
				sessionStorage.removeItem('isRefresh');
				window.location.reload();
			}

			var type = this.$route.query.type;

			if(type == 'inform') {
				this.tabId = 4;
				this.leftmenubar(3)
			} else if(type == 'problem') {
				this.tabId = 2;
				this.leftmenubar(1);
				this.graphtitleclick();
			}

		},
		created() {
			//websocket提问后回调
			window.socket.on('new_msg', function(msg){
					Bus.$emit('socket_reply',msg)		 	
		    });
		    
		},
		//进入页面执行
		mounted() {
			let _this=this;
			Bus.$on('News',(data) => {
				if(data.type == 'inform'){
					document.getElementById('newsclick').click();
				}
			})
			// 后台对题问回复后更新数据
			Bus.$on('socket_reply', data => {//data 为后台返回的问题ID
				_this.$http
					.get(_this.apiUrl+'index.php?m=Api&c=user&a=my_questions_one', {
						params: {
							userCode: sessionStorage.getItem('usercode'),
							code:data
						}
					})
					.then(
						response => {
							//判断请求的是什么数据
							if(response.body.data.type == '1') {
								_this.questionDemoData[data] = response.body.data;
							} else if(response.body.data.type == '2') {
								_this.questionGraphData[data] = response.body.data;
							} else if(response.body.data.type == '3') {
								_this.questionKnowledgeData[data] = response.body.data;
							}
						},
						response => {
//							console.log('error');
						}
					);
			})
			
			//判断用户是否登录
			if(sessionStorage.getItem( 'usercode') == null) {
				
				this.$message({
					
					message: '请先登录',
					
					type: 'warning',
					
					customClass: 'message-warning',
					
				});
				
				this.$router.push('/enterPage');
			}

			//判断是不是查看消息的
			var type = this.$route.query.type;
			
			if(type == 'inform') {
				
				this.tabId = 4;
				
				this.leftmenubar(3)
				
			} else if(type == 'problem') {
				
				this.tabId = 2;
				
				this.leftmenubar(1);
				
				this.graphtitleclick();
			}

			//获取用户基本信息
			this.$http
				.get(_this.apiUrl+'index.php?m=Api&c=user&a=user_query', {
					params: {
						userCode: sessionStorage.getItem('usercode')
					}
				})
				.then(
					response => {
						//进行数据验证
						if(response.body.status != 1) {
							//显示错误页面
							return;
						}

						if(
							typeof response.body.data == 'undefined' 
							|| response.body.data == null 
							|| response.body.data == ''
						) {
							//显示空数据页面
							return;
						}

						this.initialCompany = response.body.data.company;
						this.alterName=response.body.data.name;
						this.initialName = response.body.data.name||response.body.data.phone;//robin 没有默认昵称用手机号作为昵称 20181129
						this.initialPhone = response.body.data.phone;
						this.initialPortrait =_this.apiUrl+ response.body.data.portrait;
					},
					response => {
//						console.log('error');
					}
				);
		},
		methods: {
			toggleShow() {
				this.show = !this.show;
			},
			cropSuccess(alterPortrait, field) {
				this.alterPortrait = alterPortrait;
			},
			// 关闭修改手机号弹窗
			quitresetnumber() {
				this.flag_full_mark = false;
				this.reset_number_flag1 = false;
			},
			// 打开修改手机号弹窗
			enterresetnumber(event) {
				this.flag_full_mark = true;
				this.reset_number_flag1 = true;
			},
			// 关闭修改密码弹窗
			quitresetpassword() {
				this.password2='';
				this.password3='';
				this.password4='';
				this.flag_full_mark = false;
				this.reset_password_flag = false;
			},
			// 打开修改密码弹窗
			enterresetpassword(event) {
				this.flag_full_mark = true;
				this.reset_password_flag = true;
			},

			//修改信息
			updateInfo() {
				let _this=this;
				//判断与没有数据被修改
				if(
					this.initialName == this.alterName &&
					this.initialCompany == this.alterCompany &&
					this.alterPortrait == ''
				) {
					//              alert('没有要修改的数据');
					this.$message({
						message: '没有要修改的数据',
						type: 'warning',
						customClass: 'message-warning',
					});
					return;
				}

				//判断有没有数据为空
				if(this.alterName == '') {
					//              alert('数据不能为空');
//					this.alterName =this.initialName;
					this.$message({
									message:'姓名不能为空',
									type: 'warning',
									customClass: 'message-warning',
								});
					return;
				}

				this.$http
					.post(
						_this.apiUrl+'index.php?m=Api&c=user&a=userInfoEdit', {
							userCode: sessionStorage.getItem('usercode'),
							name: this.alterName,
							company: this.alterCompany,
							portrait: this.alterPortrait
						}, {
							emulateJSON: true
						}
					)
					.then(
						response => {
							//进行数据验证
							if(response.body.status != '1') {
								//显示错误页面
//			                 alert(response.body.message);
							this.$message({
									message:response.body.message,
									type: 'warning',
									customClass: 'message-warning',
								});
								return;
							} else {
								this.initialName = this.alterName || this.initialName;
								this.initialCompany = this.alterCompany;
								if(this.alterPortrait != '') {
									this.initialPortrait = this.alterPortrait;
									sessionStorage.setItem('portrait', response.body.data.portrait);
//									this.$refs.commonhead.portrait = response.body.data.portrait;
									Bus.$emit('portrait',{'portrait':response.body.data.portrait})
								}
								this.$message({
									message: '修改成功',
									type: 'warning',
									customClass: 'message-warning',
								});
							}
						},
						response => {
//							console.log('error');
						}
					);
			},
			//密码验证
			passwordVerification() {
				let that = this;
				let message = document.getElementById('user_passwordm')
				let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
				if(that.password1) {
					if(reg.test(that.password1)) {
						that.password_verification_flag = 1;
						message.innerText = '';
						return true;
					} else {
						that.password_verification_flag = '';
						message.innerText = '密码格式错误';
						return false;
					}
				} else {
					that.password_verification_flag = '';
					message.innerText = '密码不能为空';
					return false;
				}
			},
			startTime(time){
				
				let timer = setInterval(() => {
					time--
					if(time == 0){
						this.user_timer_flag = true;
						this.codeStr = '发送短信验证码'
						clearInterval(timer)
					}else{
						this.codeStr = time + 's后重新发送'
						this.user_timer_flag = false
					}
				},1000)
			},
									//手机短信验证
			SMSVerification() {
				let _this=this;
				let message=document.getElementById('user_SMSmes')
				if(_this.UserSMSCode){
					_this.$http.get(_this.apiUrl+'index.php?m=Api&c=Login&a=verifyCode', {
						params: {
							'phone': _this.alterPhone,
							'code': _this.UserSMSCode
						}
					}).then(
						response => {
							//进行数据验证
							if(response.body.status=='1'){
								_this.phone_verification_flag = true;
								_this.updatePhone();
								return ;
							}
							if(response.body.status == '2'){
							message.innerText='验证码错误';
							_this.phone_verification_flag = '';
								return;
							};
							if(response.body.status == '3'){
							message.innerText='验证码失效'
							_this.phone_verification_flag = '';
								return;
							}
						},
						response => {
//							console.log('error');
						}
					);
				}else{
					_this.sms_f = '';
					message.innerText = '请输入短信验证码'		
					return false;
				}
			},
			//确认密码
			cuePassword() {				
				let message = document.getElementById('cue_passwordm')
				let that = this;
				if(that.cue_password){
					if(that.password !== that.cue_password) {
					message.innerText = '两次密码不一致';
					return false;
					} else {
						message.innerText = '';
						that.cue_password_flag=1;
						return true;
					}
				}else{
					message.innerText = '请确认密码';
					that.cue_password_flag='';
					return false;
				}
			},
			//获取验证码
			getCode() {
				let _this=this;
				this.phoneVerification();
				this.passwordVerification();
				if(this.password_verification_flag&&this.phone_flag ){
						if(this.user_timer_flag){
								this.user_timer_flag = false;
								this.startTime(60)
								this.$http.get(_this.apiUrl+'index.php?m=Api&c=login&a=sendCode', {
						params: {
							old_phone:sessionStorage.getItem('phone'),
							phone: this.alterPhone,
							type: '3',
							password:_this.password1
						}
					})
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//显示错误页面
								this.$message({
									message: response.body.message,
									type: 'error',
									customClass: 'message-warning',
								});  
								this.user_timer_flag = true
								return;
							}
							this.$message({
									message: '验证码发送成功',
									type: 'success',
									customClass: 'message-warning',
								}); 
							this.SMSCode = response.body.data.code;
							
						},
						response => {
							this.user_timer_flag = true
						}
					);
								}
					
				}
				//发送验证码
				
			},

			//修改手机号
			updatePhone() {
				let _that = this;
				_that.phoneVerification();
				_that.passwordVerification();
				if(_that.password_verification_flag&&_that.phone_flag){
					_that.$http
					.post(
						_that.apiUrl+'index.php?m=Api&c=user&a=userPhoneEdit', {
							userCode: sessionStorage.getItem('usercode'),
							phone: _that.alterPhone,
							password: _that.password1
						}, {
							emulateJSON: true
						}
					)
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//显示错误页面
								_that.$message({
									message: response.body.message,
									type: 'warning',
									customClass: 'message-warning',
								});
								return;
							} else {
								_that.initialPhone = _that.alterPhone;
								_that.flag_full_mark = false;
								_that.reset_number_flag1 = false;
								_that.flag_full_mark = false;
								_that.reset_number_flag1 = false;
								_that.$message({
									message: '修改成功',
									type: 'success',
									customClass: 'message-warning',
								});
								if(sessionStorage.getItem('phone') == sessionStorage.getItem('phone')){
									localStorage.clear();
								};
								document.getElementById('home_head_exit').click()
								_that.$router.push({
									'name':'enterPage',
									query:{'re_phone':_that.initialPhone}
								})
								
							}
						},
						response => {
//							console.log('error');
						}
					);
				}
				//修改手机号
				
			},

			//修改密码
			updatePassword() {
				let _this=this;
				//判断密码是否为空,是否正确
				if(this.password2 == '' || this.password3 == '' || this.password4 == '') {
					this.$message({
					message: '请输入密码',
					type: 'warning',
					customClass: 'message-warning',
				});
					return false;
				}else{
					
					let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
					
					if(!(reg.test(this.password2)&&reg.test(this.password3)&&reg.test(this.password4))){
					
					this.$message({
					
					message: '密码格式不正确',
					
					type: 'warning',
					
					customClass: 'message-warning',
				
					});
				
					return false;
					}
					
				}
				
				if(this.password3 != this.password4) {
					this.$message({
					message: '密码不一致',
					type: 'error',
					customClass: 'message-warning',
				});
		
					return;
				}

				//修改密码
				this.$http
					.post(
						_this.apiUrl+'index.php?m=Api&c=user&a=userPasswordEdit', {
							userCode: sessionStorage.getItem('usercode'),
							originalPassword: this.password2,
							newPassword: this.password3
						}, {
							emulateJSON: true
						} 
					)
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//提示错误信息
								this.$message({
									message: response.body.message,
									type: 'warning',
									customClass: 'message-warning',
								});
								return;
							} else {
								this.$message({
									message: '修改成功',
									type: 'success',
									customClass: 'message-warning',
								});
								if(localStorage.getItem('phone')==sessionStorage.getItem('phone')){
									localStorage.clear();
								}
								this.password2='';
								this.password3='';
								this.password4='';
								this.flag_full_mark = false;
								this.reset_password_flag = false;
								document.getElementById('home_head_exit').click()
								this.$router.push({
									name:'enterPage',
									query:{
										're_phone':this.initialPhone
									}
								})
							}
						},
						response => {
//							console.log('error');
						}
					);
			},
			// 手机号验证
			phoneVerification() {
				let that = this;
				let message = document.getElementById('user_newphonem')
				let reg = /^1[3-9]{1}[0-9]{9}$/;
				if(that.alterPhone) {
					if(reg.test(that.alterPhone)) {
						that.phone_flag = 1;

						message.innerText = '';
						return true;
					} else {
						that.phone_flag = '';
						message.innerText = '请输入正确的手机号'
						return false;
					}
				} else {
					that.phone_flag = '';
					message.innerText = '手机号不能为空'
					return false;
				}

			},
			//获取提问信息
			getQuestion() {
				let _this=this;
				//判断数据是否存在
				/*if(this.questionType == '1' && this.questionDemoData != '') {
					return;
				}
				if(this.questionType == '2' && this.questionGraphData != '') {
					return;
				}
				if(this.questionType == '3' && this.questionKnowledgeData != '') {
					return;
				}*/

				//请求数据
				this.$http
					.get(_this.apiUrl+'index.php?m=Api&c=user&a=my_questions', {
						params: {
							userCode: sessionStorage.getItem('usercode'),
							type: this.questionType
						}
					})
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//显示错误页面
								return;
							}

							if(
								typeof response.body.data == 'undefined' ||
								response.body.data == null ||
								response.body.data == ''
							) {
								//显示空数据页面
								return;
							}
							//判断请求的是什么数据
							if(this.questionType == '1') {
								this.questionDemoData = response.body.data;
							} else if(this.questionType == '2') {
								this.questionGraphData = response.body.data;
							} else if(this.questionType == '3') {
								this.questionKnowledgeData = response.body.data;
								
							}
						},
						response => {
//							console.log('error');
						}
					);
			},

			//获取收藏数据
			getCollect() {
				let _this=this;
				//判断数据是否存在
				if(this.collectType == '1' && this.collectDemoData != '') {
					return;
				}
				if(this.collectType == '2' && this.collectGraphData != '') {
					return;
				}
				if(this.collectType == '3' && this.collectKnowledgeData != '') {
					return;
				}

				//请求数据
				this.$http
					.get(_this.apiUrl+'index.php?m=Api&c=user&a=getCollectionList', {
						params: {
							userCode: sessionStorage.getItem('usercode'),
							type: this.collectType
						}
					})
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//显示错误页面
								return;
							}
							if(
								typeof response.body.data == 'undefined' ||
								response.body.data == null ||
								response.body.data == ''
							) {
								//显示空数据页面
								//                          alert('没有数据');
								_this.$nextTick(() => {
									if(_this.collectType == '1') {
								_this.common.dataValidation('demo_store_nodata',500);
							} else if(_this.collectType == '2') {
								_this.common.dataValidation('graph_store_nodata',500)
							} else if(_this.collectType == '3') {
								_this.common.dataValidation('knowledge_store_nodata',500)
							}
								})
								return;
							}

							//判断请求的是什么数据
							if(this.collectType == '1') {
								this.collectDemoData = response.body.data;
								// 收藏数量超过1000显示999+
								this.collectDemoData.forEach((item,index) => {
									if(item.vc_page_view>999){
										item.vc_page_view='999+'
									}
								});
							} else if(this.collectType == '2') {
								this.collectGraphData = response.body.data;
								// 收藏数量超过1000显示999+
								this.collectGraphData.forEach((item,index) => {
									if(item.vc_page_view>999){
										item.vc_page_view='999+'
									}
								});
							} else if(this.collectType == '3') {
								this.collectKnowledgeData = response.body.data;
							}
						},
						response => {
//							console.log('error');
						}
					);
			},

			//获取提问数据
			getInform() {
				let _this=this;
				//判断数据是否存在
				// if(this.informData != '') {
				// 	return;
				// }

				//请求数据
				this.$http
					.get(_this.apiUrl+'index.php?m=Api&c=user&a=getInformList', {
						params: {
							userCode: sessionStorage.getItem('usercode')
						}
					})
					.then(
						response => {

							//进行数据验证
							if(response.body.status != 1) {
								//显示错误页面
								return;
							}

							if(
								typeof response.body.data == 'undefined' ||
								response.body.data == null ||
								response.body.data == ''
							) {
								//显示空数据页面
								return;
							}

							this.informData = response.body.data;
							sessionStorage.removeItem('isDot');
							Bus.$emit('dot',{'isDot':false})
							this.saveInform(this.informData[0].dt_careatetime);
						},
						response => {
//							console.log('error');
						}
					);

			},
			saveInform(time){
				let _this=this;
				// //判断数据是否存在
				// if(this.informData != '') {
				// 	return;
				// }
//				console.log(time);

				//修改接口
				this.$http
					.get(_this.apiUrl+'index.php?m=Api&c=user&a=saveInform', {
						params: {
							time:time
						}
					})
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//显示错误页面
								return;
							}
//							console.log(response.body);
						},
						response => {
//							console.log(response.body);
						}
					);
			},

			//左侧样式
			leftmenubar(num) {
				let tabIds = document.getElementsByClassName('tabId');
				for(let index = 0; index < tabIds.length; index++) {
					tabIds[index].style.background = 'none';
					tabIds[index].style.color = '#212121';
					tabIds[index].children[0].style.color = '#076CF2';
					tabIds[index].children[0].style.background = '#E7F0FF';
				}
				tabIds[num].style.background = '#076CF2';
				tabIds[num].style.color = 'white';
				tabIds[num].children[0].style.color = 'white';
				tabIds[num].children[0].style.background = '#076CF2';
			},

			//demotitle样式
			demotitlestyle(num) {
				let demotitleIds = document.getElementsByClassName('demotitleId');
				for(let index = 0; index < demotitleIds.length; index++) {
					demotitleIds[index].style.borderBottom = 'white';
					demotitleIds[index].style.color = '#AAAAAA';
					demotitleIds[index].style.fontWeight = '400';
				}
				demotitleIds[num].style.borderBottom = '2px solid #076CF2';
				demotitleIds[num].style.color = '#076CF2';
				demotitleIds[num].style.fontWeight = '700';
			},
			//模拟点击
			demotitleclick() {
				document.getElementById('demotitleclick').click();
			},
			graphtitleclick(type='1') {
				document.getElementById('graphtitleclick'+type).click();
			},
			resetclick() {
				document.getElementById('resetclick').click();
			},
			questionclick() {
				document.getElementById('questionclick').click();
			},
			storeclick() {
				document.getElementById('storeclick').click();
			},
			//上一步模拟点击
			prestepclick() {
				document.getElementsByClassName('vicp-operate')[0].children[0].click();
			},
			//graphtitle样式
			graphtitlestyle(num) { 
				let graphtitleIdS = document.getElementsByClassName('graphtitleId');
				for(let index = 0; index < graphtitleIdS.length; index++) {
					graphtitleIdS[index].style.borderBottom = 'white';
					graphtitleIdS[index].style.color = '#AAAAAA';
					graphtitleIdS[index].style.fontWeight = '400';
				}
				graphtitleIdS[num].style.borderBottom = '2px solid #076CF2';
				graphtitleIdS[num].style.color = '#076CF2';
				graphtitleIdS[num].style.fontWeight = '700';  
			},
			//追问
			questionask(index, type) {
				let askbtn = document.getElementsByClassName('reask' + type + index)[0];
				let textbtn = document.getElementsByClassName('askedbox' + type + index)[0];
				textbtn.style.display = 'block';
				askbtn.style.display = 'none';
			},
			//提交问题
			questionsub(index, uuid, type) {
				let _this=this;
				var content = document.getElementById(uuid+'s').value;
				if(content == '') {
					//              alert('请输入要追问的内容');
					return;
				}
				//追问
				this.$http
					.post(
						_this.apiUrl+'index.php?m=Api&c=user&a=questions_add', {
							userCode: sessionStorage.getItem('usercode'),
							problemCode: uuid,
							content: content
						}, {
							emulateJSON: true
						}
					)
					.then(
						response => {
							//进行数据验证
							if(response.body.status != 1) {
								//                          alert(response.body.message);
								return;
							} else {
								//插入数据
								if(this.questionType == '1') {
									this.questionDemoData[index].reply.push({
										content: content,
										createtime: response.body.data,
										type: '2'
									});
								}
								if(this.questionType == '2') {
									this.questionGraphData[index].reply.push({
										content: content,
										createtime: response.body.data,
										type: '2'
									});
								}
								if(this.questionType == '3') {
									this.questionKnowledgeData[index].reply.push({
										content: content,
										createtime: response.body.data,
										type: '2'
									});
								}

								let submitbtn = document.getElementsByClassName(
									'askedbox' + type + index
								)[0];
								let askbtn = document.getElementsByClassName('reask' + type + index)[0];
								submitbtn.style.display = 'none';
								askbtn.style.display = 'block';
								document.getElementById(uuid+'s').value='';
							}
						},
						response => {
//							console.log('error');
						}
					);
			},
			//显示demo简介
			showShade(index) {
				let demoshadebox = document.getElementsByClassName('demoshadebox' + index)[0];
				demoshadebox.style.display = 'table';
			},
			//隐藏demo简介
			hideShade(index) {
				let demoshadebox = document.getElementsByClassName('demoshadebox' + index)[0];
				demoshadebox.style.display = 'none';
			},
			//跳转知识库详情
			jumpRepositoryDetail(uuid) {
				this.$router.push({
					path: '/repository1',
					query: {
						uuid: uuid
					}
				})
			},
			//跳转到demo详情
			jumpdemodetail(uuid) {
				this.$router.push({
					path: '/demodetail',
					query: {
						uuid: uuid
					}
				})
			},
			//跳转到图谱库详情
			jumpgraphdetail(uuid) {
				this.$router.push({
					path: '/atlasdetails',
					query: {
						uuid: uuid
					}
				})
			},

			//查看问题
			lookProblems(type,uuid){
				this.tabId=2;
				this.leftmenubar(1);
				this.graphtitleclick(type);
			}
		}
	};
</script>

<style>
	.none_data_text{
		width: 100%;
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #076bf2;
		font-size: 24px;
	}
	#user_SMSmes{
		width: 354px;
	}
	.myvip_wrap{
		padding-bottom: 20px;
		height: auto;
		background: #f3f3f3;
	}
	#user_rephone_t{
		float: left;display:  block;height: 40px;line-height: 40px;font-size: 18px;
	}
	#user_rephone_b{
		float: left;display:  block;height: 40px;line-height: 40px;font-size: 24px;
	}
	.myvip_main{
		position: relative;width: 1200px;margin: 0 auto;
	}
	/*.myvip_main{
		width: 1200px;margin: 0 auto;overflow: hidden;
	}*/
	.myvip_wrap li {
		list-style: none;
	}
	
	.vipbanner {
		width: 100%;
	}
	
	.vipsidenav {
		position: absolute;
		width: 250px;
		height: 840px;
		background: white;
		left: 0;
		/*float: left;*/
		top: -60px;
		/*margin-top: -60px;*/
		border-radius: 5px;
	}
	/*左侧菜单栏*/
	
	.vipsidenav li {
		width: 210px;
		margin: 10px 20px;
		cursor: pointer;
	}
	
	.vipsidenav .tabId0 {
		padding-top: 10px;
		border-bottom: 1px solid #eaeaea;
	}
	
	.vipsidenav .tabId0 .head_portrait {
		height: 100px;
		width: 100px;
		display: block;
		margin: 0 auto;
		/*margin-bottom: 10px;*/
		border-radius: 50%;
	}
	
	.vipsidenav .tabId0 .head_portrait img {
		height: 90px;
		width: 90px;
		display: block;
		margin: 0 auto;
		border-radius: 50%;
	}
	
	.vipsidenav .tabId0 .usern {
		display: block;
		margin: 0px auto;
		padding-bottom: 25px;
	}
	
	.vipsidenav>.tabId {
		height: 40px;
		line-height: 40px;
		color: #212121;
		border-radius: 20px;
	}
	
	.vipsidenav>.tabId>a {
		margin-left: -10px;
		margin-right: 20px;
		display: inline-block;
		height: 30px;
		line-height: 30px;
		width: 30px;
		color: #076cf2;
		background: #e7f0ff;
		border-radius: 50%;
	}
	
	.vipbanner>img {
		width: 100%;
		display: block;
	}
	
	.vipstoremain {
		width: 920px;
		min-height: 840px;	
		position: relative;
		left: 250px;
		top: -60px;
		margin-left: 20px;
		margin-bottom: 0;
		/*float: right;
		margin-top: -60px;*/
	}
	
	.vipstoremain>h4 {
		height: 40px;
		line-height: 40px;
		text-align: left;
		color: white;
	}
	
	.mystore {
		text-align: left;
		width: 920px;
		min-height: 760px;
	}
	
	.menuname i {
		color: #027fe9;
	}
	
	.mystore>ul {
		padding: 50px 0 0 50px;
	}
	
	.mystore>ul li {
		list-style: none;
	}
	
	.mystore>ul li a {
		list-style: none;
		color: #666666;
	}
	
	.mystore>ul li>.menuname {
		display: inline-block;
		width: 170px;
		height: 60px;
		line-height: 60px;
	}
	
	.navbottom {
		padding: 100px 0 0 40px;
	}
	
	.navbottom>.navbtn {
		padding: 10px 30px;
		background: #e7f0ff;
		margin: 10px;
		cursor: pointer;
		color: #2978f2;
	}
	/*demo收藏样式*/
	
	.demo_wrap_box .store_title,
	.graph_wrap_box .store_title {
		padding-left: 3%;
		overflow: hidden;
		width: 97%;
		height: 40px;
		background: white;
		border-radius: 4px;
		margin-bottom: 10px;
	}
	
	.store_title>.demotitleId,
	.store_title>.graphtitleId {
		padding: 0 3px;
		height: 38px;
		float: left;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		margin: 0 8px;
		border-bottom: 2px solid white;
	}
	
	.store_content {
		width: 100%;
		height: 100%;
	}
	
	.question_content_main,
	.demo_store_content,
	.graph_store_content,
	.storeknowledge_wrap {
		width: 100%;
		min-height: 760px;
		overflow: hidden;
	}
	.demo_store_content>li>span:hover>div{
		display: table;
	}
	/*滚动条样式*/
	
	.news_content_box::-webkit-scrollbar,
	.question_content_main::-webkit-scrollbar,
	.demo_store_content::-webkit-scrollbar,
	.graph_store_content::-webkit-scrollbar,
	.storeknowledge_wrap::-webkit-scrollbar {
		width: 10px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 10px;
	}
	
	.news_content_box::-webkit-scrollbar-thumb,
	.question_content_main::-webkit-scrollbar-thumb,
	.demo_store_content::-webkit-scrollbar-thumb,
	.graph_store_content::-webkit-scrollbar-thumb,
	.storeknowledge_wrap::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}
	
	.news_content_box::-webkit-scrollbar-track,
	.question_content_main::-webkit-scrollbar-track,
	.demo_store_content::-webkit-scrollbar-track,
	.graph_store_content::-webkit-scrollbar-track,
	.storeknowledge_wrap::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #EDEDED;
	}
	
	.demo_store_content li {
		position: relative;
		list-style: none;
		background: white;
		width: 290px;
		height: 250px;
		margin: 8px;
		float: left;
	}
	
	.demo_store_content li>h3 {
		padding: 0 8px;
		width: 274px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #222222;
		text-align: left;
	}
	.demo_store_content li>h3 span[id^='showshade_span']{
		float: right;line-height:40px ;height: 40px;margin-right: 5px;
	}
	.demo_store_content li>.bookmark {
		border-top: 1px solid #f3f3f3;
		padding: 0 8px 0 8px;
		width: 274px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color: #999999;
		text-align: right;
	}
	.demo_store_content .urlbox {
		margin: 0 8px 3px 8px;
		width: 274px;
		height: 175px;
		background: #f3f3f3;
	}
	
	.demo_store_content .urlbox>img {
		display: block;
		width: 100%;
		height: 175px;	
	}
	
	.demo_store_contentbox>h3 {
		width: 280px;
		font-size: 18px;
		text-align: left;
		color: #8793a1;
		margin-left: 10px;
		overflow: hidden;
	}
	.demo_store_content li>h3 span[id^='showshade_span']:hover div[class^='demoshadebox']{
		display: table;
	}
	.demo_store_content div[class^='demoshadebox'] {
		overflow: hidden;
		word-wrap: break-word;
		background: rgba(0, 0, 0, 0.6);
		width: 290px;
		height: 250px;
		position: absolute;
		left: 0;
		top: 0;
		display: none;
		z-index: 100;
	}
	
	.demo_store_content div[class^='demoshadebox'] .demostoremark {
		color: white;
		width: 250px;
		padding: 0 20px;
		display: table-cell;
		vertical-align: middle;
		line-height: 24px;
		font-family: "微软雅黑";
	}
	/*graph收藏样式*/
	
	.graph_store_content {
		width: 100%;
		/*height: 760px;*/
		margin-top: 10px;
		/*overflow: auto;*/
	}
	
	.graph_store_content li {
		position: relative;
		list-style: none;
		background: white;
		width: 290px;
		height: 270px;
		margin: 8px;
		float: left;
	}
	
	.graph_store_content li>h3 {
		padding: 0 8px;
		width: 274px;
		height: 45px;
		line-height: 45px;
		font-size: 14px;
		color: #222222;
		text-align: left;
	}
	
	.graph_store_content li>.bookmark {
		border-top: 1px solid #f3f3f3;
		/*padding: 0 8px 0 226px;*/
		width: 56px;
		background-size: 22px 30px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #222222;
		text-align: center;
	}
	
	.graph_store_content .urlbox {
		margin: 10px 8px 0px 8px;
		width: 274px;
		height: 175px;
		background: #f3f3f3;
		position: relative;
	}
	.graph_store_content .urlbox:hover .graphshadebox{
		display: table;
	}
	.graph_store_content .urlbox>img {
		display: block;
		margin: 0 auto;
		width: 274px;
		height: 175px;
	}
	
	.graph_store_content>h3 {
		width: 280px;
		font-size: 18px;
		text-align: left;
		color: #8793a1;
		margin-left: 10px;
	}
	
	.graph_store_content .urlbox .graphshadebox {
		overflow: hidden;
		word-wrap: break-word;
		background: rgba(0, 0, 0, 0.6);
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		display: none;
		z-index: 100;
	}
	
	.graph_store_content .urlbox .graphshadebox .graphstoremark {
		font-family: "微软雅黑";
		color: white;
		width: 250px;
		padding: 0 20px;
		display: table-cell;
		vertical-align: middle;
		line-height: 24px;
	}
	/*知识库收藏*/
	
	.storeknowledge_wrap {
		/*height: 760px;*/
		/*width: 100%;*/
		/*overflow: auto;*/
	}
	/*修改密码*/
	
	#app>.head_img_box {
		width: 110px;
		height: 110px;
		border-radius: 50%;
		overflow: hidden;
		outline: 0;
		border: 0;
	}
	#app>.head_img_box>img{
		height: 110px;
		width: 110px;
		display: block;
		cursor: pointer;
		border-radius: 50%;
	}
	#app>.btn {
		font-size: 14px;
		line-height: 30px;
		cursor: pointer;
	}
	
	.resetfinish {
		display: block;
		height: 40px;
		line-height: 40px;
		background: #076BF2;
		/*background: -webkit-linear-gradient(30deg, #65d2ff, #076bf2);
		background: -o-linear-gradient(30deg, #65d2ff, #076bf2);
		background: -moz-linear-gradient(30deg, #65d2ff, #076bf2);
		background: linear-gradient(30deg, #65d2ff, #076bf2);*/
		border-radius: 20px;
		font-size: 16px;
		width: 160px;
		margin: 0 auto;
		color: white;
		cursor: pointer;
	}
	
	#resetpwd_wrap {
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 350px;
		border-radius: 5px;
	}
	
	#resetpwd_wrap .resetpwd_wrap_top {
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #f3f7f9;
		width: 474px;
	}
	
	#resetpwd_wrap .resetpwd_wrap_main {
		width: 460px;
		margin: 0 auto;
		margin-top: 30px;
		height: 310px;
	}
	
	.resetpwd_wrap_main {
		width: 354px;
		height: 250px;
		margin: 30px auto;
	}
	#pwd_qwe{
		height: 40px;
		line-height: 40px;
		font-size: 18px;
	}
	#pwd_qwe1{
		height: 40px;
		line-height: 40px;
		font-size: 24px;
	}
	.oldpwd,
	.newpwd,
	.newpwd1 {
		margin: 0 auto;
		width: 354px;
		height: 68px;
	}
	
	.oldpwd input,
	.newpwd input,
	.newpwd1 input {
		width: 100%;
		height: 46px;
		border: 1px solid #999999;
		text-indent: 1em;
		border-radius: 4px;
		font-size: 14px;
	}
	
	.newpwd span,
	.newpwd1 span {
		display: block;
		height: 20px;
		line-height: 20px;
		color: red;
		text-align: left;
	}
	
	.vipbanner {
		width: 100%;
	}
	
	.vipbanner>img {
		width: 100%;
		display: block;
	}
	
	.vipstoremain>h4 {
		height: 40px;
		line-height: 40px;
		text-align: left;
		color: white;
	}
	
	.vipstoremain .store_title .el-menu-item {
		height: 40px;
		margin: 0 2px;
		line-height: 40px;
		float: left;
	}
	
	.vipstoremain .store_title .el-menu--collapse {
		width: 920px;
	}
	
	.mystore {
		text-align: left;
		width: 920px;
		/*height: 760px;*/
		background: white;
	}
	
	.basic_information {
		width: 100%;
		height: 450px;
		border-bottom: 1px solid #e5e5e5;
	}
	.basic_information>h4{
		text-indent: 50px ;
		height: 66px;
		line-height:66px ;
		position: relative;
		margin-bottom: 40px;
		font-size: 16px;
	}
	.basic_information .updatebutton {
		position: absolute;
		right: 50px;
		height: 36px;
		line-height: 36px;
		display: inline-block;
		border-radius: 18px;
		top: 15px;
		/*background: -webkit-linear-gradient(30deg, #65d2ff, #076bf2);
		background: -o-linear-gradient(30deg, #65d2ff, #076bf2);
		background: -moz-linear-gradient(30deg, #65d2ff, #076bf2);
		background: linear-gradient(30deg, #65d2ff, #076bf2);*/
		background: #076bf2;
		color: white;
		text-align: center;
		text-indent: 0;
		width: 100px;
	}
	
	.basic_information_content {
		margin-left: 180px;
	}
	
	.basic_information_content>li {
		list-style: none;
		height: 40px;
		line-height: 40px;
		margin-bottom: 20px;
		font-size: 16px;
	}
	
	.basic_information_content li .title {
		width: 90px;
		text-align: justify;
		text-align-last: justify;
		display: inline-block;
		margin-right: 45px;
		color: #bdbdbd;
		font-size: 16px;
	}
	
	.basic_information_content li .inp {
		height: 40px;
		line-height: 40px;
		display: inline-block;
		width: 360px;
		font-size: 16px;
	}
	.basic_information_content li .inp>span{
		font-size: 16px;
	}
	.basic_information_content li .inp>input {
		height: 100%;
		width: 100%;
		text-indent: 16px;
		background: #f7f7f7;
		border: #e5e5e5 1px solid;
		border-radius: 5px;
		color: #212121;
		/*font-size: 14px;*/	
	}
	
	.head_portrait_box {
		width: 110px;
		height: 110px;
		background: url(../assets/images/defaultheadpicture.png) no-repeat center;
		margin: 0 300px;
		border-radius: 50%;
	}
	.resetheadpicture{
		display: inline-block;
		padding: 10px 0;
		cursor: pointer;
	}
	.safety_information .basic_information_content>li>a {
		color: #076bf2;
		font-size: 16px;
	}
	.safety_information>h4{
		text-indent: 50px ;height: 66px;line-height:66px ;
	}
	.safety_information>.basic_information_content>li>.inp {
		text-indent: 16px;
	}
	
	.full_mark_box {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.5);
	}
	
	#reset_number_wrap {
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 350px;
		border-radius: 5px;
	}
	
	#reset_number_wrap .reset_number_wrap_top {
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #f3f7f9;
		width: 474px;
	}
	
	#reset_number_wrap .reset_number_wrap_main {
		width: 354px;
		margin: 38px auto;
		height: 67px;
	}
	
	#reset_number_wrap .reset_number_wrap_main .phonenum {
		width: 354px;
		height: 67px;
		font-size: 14px;
	}
	
	.reset_number_wrap_main .phonenum>input {
		border-radius: 4px;
		width: 332px;
		height: 45px;
		border: 1px solid #aaaaaa;
		outline: ;
		padding: 0 10px;
	}
	
	.reset_number_wrap_main .phonenum span {
		width: 354px;
		height: 20px;
		font-size: 16px;
		line-height: 20px;
		color: red;
	}
	
	.reset_phone_verification {
		width: 100%;
		height: 70px;
	}
	
	.reset_phone_verification>input {
		text-indent: 10px;
		float: left;
		width: 210px;
		height: 38px;
		border: 1px solid #aaaaaa;
	}
	
	.reset_phone_verification>a {
		cursor: pointer;
		float: right;
		/*margin-left: 10px;*/
		width: 140px;
		height: 40px;
		line-height: 40px;
		color: #5a9cf6;
		background: #e6f0fe;
		border-radius: 4px;
		font-size: 16px;
	}
	
	.submit_reset_number_finish {
		cursor: pointer;
		display: block;
		height: 40px;
		line-height: 40px;
		border-radius: 20px;
		font-size: 16px;
		width: 160px;
		margin: 0px auto;
		color: white;
		background: #076BF2;
		/*background: -webkit-linear-gradient(30deg, #65d2ff, #076bf2);
		background: -o-linear-gradient(30deg, #65d2ff, #076bf2);
		background: -moz-linear-gradient(30deg, #65d2ff, #076bf2);
		background: linear-gradient(30deg, #65d2ff, #076bf2);*/
	}
	
	.el-icon-thirdicon-kongxintixing-tanhao {
		color: #bdc3d4;
	}
	/*我的提问*/
	
	.question_content {
		padding-top: 10px;
		background: none;
	}
	
	.question_content_main {
		background: #fff;
		width: 920px;
		/*height: 760px;*/
		font-size: 14px;
		text-align: left;
		box-sizing: border-box;
		border-radius: 5px;
		color: #999;
		/*overflow: auto;*/
	}
	
	.question_content_main .question_content_list {
		width: 870px;
		margin: 30px auto;
		/*margin-top: 30px;*/
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
		background: #f6f7f9;
	}
	
	.question_content_main .time {
		background: white;
	}
	.question_content_main .time>a {
		text-decoration: none;
		font-weight: bolder;
		color: #046cef;
	}
	
	.question_content_list .question_list_title {
		padding: 10px 0 10px 0;
		font-size: 18px;
		font-weight: bolder;
		color: #000000;
		background: white;
	}
	
	.question_content_list .reply_wrap {
		margin: 15px 20px;
		background: #f6f7f9;
		border-radius: 5px;
	}
	
	.question_content_list .reply_wrap .reply {
		/*margin-bottom: 10px;*/
	}
	
	.question_content_list .reply_wrap .cont {
		color: #000000;
	}
	
	.question_content_list>div[class^='reask'] {
		cursor: pointer;
		text-align: right;
		padding: 5px 2%;
		height: 20px;
		width: 96%;
		line-height: 20px;
		background: #f6f7f9;
		
	}
	
	.question_content_list a {
		color: #076bf2;
	}
	
	div[class^='askedbox'] {
		padding: 20px 0 20px 20px;
		display: none;
		overflow: hidden;
	}
	.quiz_box {
		float: left;
		width: 720px;
		height: 60px;
		border-radius: 5px;
		text-indent: 1em;
		/* line-height: 20px; */
		text-align: left;
		resize: none;
		background:#f6f7f9 ;
		font-size: 14px;
		outline: 0;
		border: 1px solid #999;
	}

	.bottom_space{
		height: 20px;
	}
	.quiz_button {
		float: right;
		height: 60px;
		width: 100px;
	}
	.quiz_button .quizbtn {
		cursor: pointer;
		margin: 15px auto;
		width: 68px;
		height: 30px;
		line-height: 30px;
		background: #dde9f7;
		color: #076bf2;
		text-align: center;
	}
	/*消息中心*/
	
	.news_content_box {
		text-align: left;
		width: 920px;
		/*height: 760px;*/
		background: white;
		/*overflow: auto;*/
		border-radius: 5px;
	}
	
	.news_content_box>ul {
		padding-top: 10px;
		margin: 0 auto;
	}
	
	.news_content_box>ul>h4 {
		margin: 0 auto;
		height: 50px;
		line-height: 50px;
		width: 850px;
		/*border-bottom: 1px solid #E5E5E5;*/
	}
	
	.news_content_box>ul>h4>span {
		float: left;
	}
	
	.news_content_box>ul>h4>a {
		float: right;
	}
	
	.news_content_box>ul>li {
		margin: 0 auto;
		list-style: none;
		width: 850px;
		height: 50px;
		border-bottom: 1px solid #e5e5e5;
	}
	
	.news_content_box>ul li>.menuname {
		display: block;
		height: 50px;
		line-height: 50px;
		float: left;
		padding-left: 10px;
		width: 570px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.news_content_box>ul li>.menuname1 {
		display: block;
		height: 50px;
		line-height: 50px;
		float: left;
		padding-left: 10px;
		width: 850px;
	}
	.news_content_box>ul li>a {
		display: block;
		height: 50px;
		line-height: 50px;
		float: right;
		color: #076bf2;
		cursor: pointer;
		margin-right: 150px;
	}
	.subject_middle_1>p,
	.subject_middle_3>p,
	.subject_middle_6p>p{
		margin-top: 10px
	}
	.vicp-preview-item{
		display: none;
	}
	.vicp-preview-item>img{
		height: 100%;
		width: 100%;
	}
	.vicp-preview-item-circle{
		display: block;
	}
	.vicp-preview-item-circle>img{
		height: 100%;
		width: 100%;
	}
	 .graph_store_content li>.bookmark {
		position: relative;
		border-top: 1px solid #F3F3F3;
		padding: 0 8px;
		width: 274px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #B3B3B3;
		text-align: right;
	}
	.viewbox{
		display: inline-block;
		height: 40px;
		/*width: 40px;*/
		line-height: 40px;
		text-align: right;
	}
	.viewnum{
		margin-right: 5px;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		text-align: right;
	}
	 #sourcer {
		height: 40px;
		line-height: 40px;
		position: absolute;
		font-size: 14px;
		color: #222222;
		left: 10px;
		padding-left: 40px;
		width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
	}
	.el-icon-thirdicon-morentouxiang{
		color: #B6CDEB;
	}
	#sourcer>i {
		position: absolute;
		height: 40px;
		line-height: 40px;
		left: 0;
		display: block;
		font-size: 30px;
	}
	
	.vicp-preview-item,.vicp-preview-item-circle{
		width: 120px;
		height: 120px;
	}
	.vicp-crop-right{
		height: 200px;
		width: 200px;
		float: left;
		padding-top: 20px;
	}
	.vicp-preview-item-circle {
    margin-right: 0;
    margin-top: 0;
    height: 110px;
    width: 110px;
	}
	.vicp-preview-item-circle>img{
    margin-right: 0;
    margin-top: 0;
    display: block;
    height: 110px!important;
    width: 110px!important;
	}
	#app .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview {
		height: 180px;
	}
</style>


// WEBPACK FOOTER //
// src/vip/resetPage.vue